module.exports = __webpack_public_path__ + "static/media/kabeltarto-hid-acelszerkezet.fb1d7118.jpg";